const TOKEN_KEY = 'talkali_token';
const REFRESH_TOKEN_KEY = 'talkali_refresh_token';
const USER_KEY = 'talkali_user';

function getStoredSession() {
  const token = localStorage.getItem(TOKEN_KEY) || '';
  const refreshToken = localStorage.getItem(REFRESH_TOKEN_KEY) || '';
  const rawUser = localStorage.getItem(USER_KEY);
  let user = null;

  if (rawUser) {
    try {
      user = JSON.parse(rawUser);
    } catch (_) {
      user = null;
    }
  }

  return { token, refreshToken, user };
}

function saveStoredSession({ token, refreshToken, user }) {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
  if (refreshToken) {
    localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  }
  if (user) {
    localStorage.setItem(USER_KEY, JSON.stringify(user));
  }
}

function clearStoredSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(REFRESH_TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export {
  TOKEN_KEY,
  REFRESH_TOKEN_KEY,
  USER_KEY,
  getStoredSession,
  saveStoredSession,
  clearStoredSession,
};